import {
  defineComponent, ref, onMounted,
} from 'vue';
import { Native } from '@hb/mbridge';
import TicketDetail from './components/TicketDetail';
import { isHelloFamilyApp } from '../../common/env/env';

export default defineComponent({
  name: 'TicketDetailAB',

  setup() {
    const showOldDetailPage = ref(false);
    const isLoaded = ref(false);

    onMounted(async () => {
      isLoaded.value = true;
      setTimeout(() => {
        if (isHelloFamilyApp) {
          Native.callNative({
            classMap: 'NavBar',
            method: 'setStatusBar',
            params: { isShowStatusBar: true },
          });
          Native.callNative({
            classMap: 'NavBar',
            method: 'setStatusBarColor',
            params: { isShowStatusBar: true, isDarkFont: false, colorCode: '#ffffff' },
          });
        }
      }, 100);
    });

    return {
      showOldDetailPage,
      isLoaded,
    };
  },
  render() {
    if (!this.isLoaded) {
      return null;
    }

    return <TicketDetail />;
  },
});
